class DebugConsole {
  track(event, data) {
    console.info('TRACK', event, data);
  }
}

export default DebugConsole;
